import styled from 'styled-components';

const StepsContainer = styled.div`
&&& {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    width: calc(${({ theme }) => `100% - 32px - ${theme.Spacing.spacing2x}`});
}
`;

export default StepsContainer;
